import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from "src/environments/environment";

// const authUrl = `https://login.microsoftonline.com/${environment.APP_REG_TENANT_ID}/oauth2/v2.0/authorize`;
// const clientId = environment.APP_REG_CLIENT_ID;
// const redirectUri = environment.APP_REG_REDIRECT_URL;
// const scope = environment.APP_REG_SCOPE;
// const responseType = 'code';
// const responseMode = 'query';

// const url = `${authUrl}?client_id=${clientId}&response_type=${responseType}&redirect_uri=${redirectUri}&response_mode=${responseMode}&scope=${scope}`;

// window.location.href = url; // Redirect to the OAuth provider's authorization endpoint

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
 
export const b2cPolicies = {
     names: {
         signUpSignIn: "b2c_1_susi_reset_v2",
         editProfile: "b2c_1_edit_profile_v2"
     },
     authorities: {
         signUpSignIn: {
             authority: "https://your-tenant-name.b2clogin.com/your-tenant-name.onmicrosoft.com/b2c_1_susi_reset_v2",
         },
         editProfile: {
             authority: "https://your-tenant-name.b2clogin.com/your-tenant-name.onmicrosoft.com/b2c_1_edit_profile_v2"
         }
     },
     authorityDomain: "cd99fef8-1cd3-4a2a-9bdf-15531181d65e"
 };
 
 
export const msalConfig: Configuration = {
     auth: {
         clientId: '28706c51-8add-42d3-a979-becc13ddd4ec',
         authority: b2cPolicies.authorities.signUpSignIn.authority,
         knownAuthorities: [b2cPolicies.authorityDomain],
         redirectUri: '/', 
     },
     cache: {
         cacheLocation: BrowserCacheLocation.LocalStorage,
         storeAuthStateInCookie: isIE, 
     },
     system: {
         loggerOptions: {
            loggerCallback: (logLevel, message, containsPii) => {
             },
             logLevel: LogLevel.Verbose,
             piiLoggingEnabled: false
         }
     }
 }

export const protectedResources = {
  todoListApi: {
    endpoint: "http://localhost:4200/auth",
    scopes: ["api://28706c51-8add-42d3-a979-becc13ddd4ec"],
  },
}
export const loginRequest = {
  scopes: []
};

export const SSO_SP_CONFIG = {
    tenantId: environment.APP_REG_TENANT_ID,
    clientId: environment.APP_REG_CLIENT_ID,
    redirectURL: environment.APP_REG_REDIRECT_URL,
    scope: environment.APP_REG_SCOPE
}